import { createContext, useContext, useEffect, useState, ReactNode } from "react";

type Lang = "pt" | "en";
type Theme = "dark" | "light";

const dict = {
  pt: {
    nav_home: "Início", nav_products: "Produtos", nav_orders: "Meus Pedidos", nav_admin: "Admin",
    btn_signin: "Entrar", btn_signout: "Sair",
    hero_badge: "Marketplace de ativos digitais",
    hero_title_a: "NickRobotic —", hero_title_b: "marketplace de ativos digitais com entrega imediata",
    hero_sub: "Compre contas, licenças e ativos digitais com segurança. Receba na hora, sem espera.",
    hero_cta: "Ver produtos",
    bf_instant: "Entrega instantânea", bf_instant_d: "Receba suas credenciais em segundos após o pagamento",
    bf_secure: "Segurança garantida", bf_secure_d: "Transações criptografadas e dados protegidos",
    bf_access: "Acesso imediato", bf_access_d: "Disponível 24h para você comprar quando quiser",
    featured: "Produtos em destaque", featured_sub: "Os mais vendidos do momento", see_all: "Ver todos",
    testimonials: "O que dizem nossos clientes",
    all_products: "Todos os produtos", all_sub: "Entrega automática para todos os itens em estoque",
    search_ph: "Buscar produtos...", all_categories: "Todas as categorias",
    no_products: "Nenhum produto encontrado", loading: "Carregando...",
    in_stock: "em estoque", out: "Esgotado", sales: "vendas", buy: "Comprar", buy_now: "Comprar agora",
    from: "A partir de", price: "Preço", available: "disponíveis", sales_done: "vendas realizadas",
    auto_delivery: "Entrega automática imediata", secure_pay: "Pagamento 100% seguro",
    tab_desc: "Descrição", tab_feat: "Características", tab_del: "Entrega",
    checkout: "Finalizar compra", purchase_result: "Resultado da compra",
    payment_method: "Forma de pagamento", credit: "Crédito", debit: "Débito", crypto: "Cripto",
    pay_btn: "Pagar e receber", processing: "Processando...",
    payment_mock: "Pagamento simulado (mock). Estrutura pronta para gateway real.",
    pay_approved: "Pagamento aprovado", pay_declined: "Pagamento recusado",
    your_creds: "Seus dados de acesso:", save_creds: 'Salve estes dados. Você também pode acessá-los em "Meus Pedidos".',
    view_orders: "Ver meus pedidos", try_again: "Tentar novamente",
    auth_title: "Acessar", auth_sub: "Entre ou crie sua conta para comprar",
    signin: "Entrar", signup: "Cadastrar", email: "E-mail", password: "Senha", name: "Nome",
    create_account: "Criar conta", login_required: "Faça login para comprar",
    welcome: "Bem-vindo!", account_created: "Conta criada! Verifique seu e-mail.",
    forgot_password: "Esqueci minha senha", reset_title: "Redefinir senha",
    reset_sub: "Enviaremos um link de recuperação para o seu e-mail.",
    cancel: "Cancelar", send_link: "Enviar link", sending: "Enviando...",
    inform_email: "Informe seu e-mail", reset_sent: "Enviamos um link de recuperação para seu e-mail.",
    new_password_title: "Definir nova senha", new_password_sub: "Escolha uma nova senha para sua conta.",
    validating_link: "Validando link de recuperação...",
    new_password: "Nova senha", confirm_password: "Confirmar senha",
    save_new_password: "Salvar nova senha", saving: "Salvando...",
    pwd_min: "A senha deve ter ao menos 6 caracteres", pwd_mismatch: "As senhas não coincidem",
    pwd_updated: "Senha atualizada com sucesso",
    my_orders: "Meus pedidos", my_orders_sub: "Suas credenciais ficam disponíveis aqui por 30 dias após a compra.",
    no_orders: "Você ainda não fez nenhum pedido.",
    delivered_creds: "Credenciais entregues:",
    expired_30d: "Disponibilidade expirou (30 dias).",
    expires_in: "Expira em", day: "dia", days: "dias",
    show: "Ver", hide: "Ocultar", no_creds: "Sem credenciais associadas.",
    footer_rights: "Marketplace de ativos digitais",
    // Wallet
    wallet_title: "Minha carteira", wallet_balance: "Saldo disponível",
    wallet_balance_hint: "Use o saldo para comprar qualquer produto da loja.",
    wallet_add: "Adicionar saldo", wallet_finalize: "Finalizar recarga",
    wallet_credit_label: "Crédito na carteira", wallet_you_pay: "Você paga",
    wallet_fee_provider: "Taxa do provedor (5%)", wallet_fee_fixed: "Taxa fixa do provedor",
    wallet_fees_total: "Total de taxas", wallet_total_pay: "Total a pagar",
    wallet_history: "Histórico", wallet_no_tx: "Sem movimentações ainda.",
    wallet_back: "Voltar à loja", wallet_methods: "Métodos: Cartão de crédito, débito e Pix (quando habilitado pelo provedor). A taxa cobrada pelo provedor de pagamento (5% + R$ 0,50) é repassada ao valor da cobrança — o saldo creditado na sua carteira é sempre o valor nominal escolhido.",
    wallet_custom: "Outro valor", wallet_custom_hint: "Digite quanto quer creditar (mín. R$ 10, máx. R$ 5.000)",
    wallet_continue: "Continuar", wallet_invalid_amount: "Valor inválido (R$ 10 – R$ 5.000)",
    // Product detail
    pd_unit_price: "Preço unitário", pd_quantity: "Quantidade", pd_max: "máx",
    pd_total: "Total", pd_wallet_balance: "Saldo da carteira",
    pd_add_balance: "Adicionar saldo", pd_buy_balance: "Comprar com saldo",
    pd_login_to_buy: "Entrar para comprar", pd_sold: "vendidos",
    pd_confirm_title: "Confirmar compra",
    pd_will_debit: "Será debitado", pd_balance_after: "Saldo após compra",
    pd_after_purchase: "Após a compra suas credenciais ficarão disponíveis em",
    pd_confirm_btn: "Confirmar e ir para Meus pedidos",
    pd_purchase_done: "Compra concluída! Veja em Meus pedidos.",
    pd_login_first: "Faça login para comprar",
    pd_available_30d: 'Disponível por 30 dias em "Meus pedidos"',
    // Support
    nav_support: "Suporte",
    sup_title: "Suporte", sup_sub: "Abra um ticket e nossa equipe responderá em breve.",
    sup_count: "ticket(s)", sup_open_ticket: "Abrir ticket", sup_new_ticket: "Abrir novo ticket",
    sup_no_tickets: "Você ainda não tem tickets.",
    sup_subject: "Assunto", sup_subject_ph: "Ex.: Pedido #NR-001023 não entregue",
    sup_message: "Mensagem", sup_message_ph: "Descreva o ocorrido...",
    sup_reply_ph: "Escreva sua mensagem...",
    sup_status_open: "Aberto", sup_status_closed: "Fechado",
    sup_opened_at: "Aberto em", sup_last_activity: "Última atividade:",
    sup_new_reply: "Nova resposta", sup_you: "Você", sup_support: "Suporte",
    sup_closed_msg: "Este ticket foi fechado pelo suporte.",
    sup_sending: "Enviando...", sup_too_long: "Texto muito longo", sup_msg_too_long: "Mensagem muito longa",
    sup_create_err: "Erro ao criar ticket", sup_created: "Ticket aberto",
  },
  en: {
    nav_home: "Home", nav_products: "Products", nav_orders: "My Orders", nav_admin: "Admin",
    btn_signin: "Sign in", btn_signout: "Sign out",
    hero_badge: "Digital assets marketplace",
    hero_title_a: "NickRobotic —", hero_title_b: "digital assets marketplace with instant delivery",
    hero_sub: "Buy accounts, licenses and digital assets safely. Get them instantly.",
    hero_cta: "Browse products",
    bf_instant: "Instant delivery", bf_instant_d: "Receive your credentials in seconds after payment",
    bf_secure: "Guaranteed security", bf_secure_d: "Encrypted transactions and protected data",
    bf_access: "Immediate access", bf_access_d: "Available 24/7 whenever you want to buy",
    featured: "Featured products", featured_sub: "Best sellers right now", see_all: "See all",
    testimonials: "What our customers say",
    all_products: "All products", all_sub: "Automatic delivery for every in-stock item",
    search_ph: "Search products...", all_categories: "All categories",
    no_products: "No products found", loading: "Loading...",
    in_stock: "in stock", out: "Sold out", sales: "sales", buy: "Buy", buy_now: "Buy now",
    from: "From", price: "Price", available: "available", sales_done: "completed sales",
    auto_delivery: "Instant automatic delivery", secure_pay: "100% secure payment",
    tab_desc: "Description", tab_feat: "Features", tab_del: "Delivery",
    checkout: "Checkout", purchase_result: "Purchase result",
    payment_method: "Payment method", credit: "Credit", debit: "Debit", crypto: "Crypto",
    pay_btn: "Pay and receive", processing: "Processing...",
    payment_mock: "Mock payment. Ready for real gateway integration.",
    pay_approved: "Payment approved", pay_declined: "Payment declined",
    your_creds: "Your access data:", save_creds: 'Save this data. You can also access it in "My Orders".',
    view_orders: "View my orders", try_again: "Try again",
    auth_title: "Access", auth_sub: "Sign in or create your account to buy",
    signin: "Sign in", signup: "Sign up", email: "Email", password: "Password", name: "Name",
    create_account: "Create account", login_required: "Sign in to buy",
    welcome: "Welcome!", account_created: "Account created! Check your email.",
    forgot_password: "Forgot my password", reset_title: "Reset password",
    reset_sub: "We'll send a recovery link to your email.",
    cancel: "Cancel", send_link: "Send link", sending: "Sending...",
    inform_email: "Enter your email", reset_sent: "We sent a recovery link to your email.",
    new_password_title: "Set new password", new_password_sub: "Choose a new password for your account.",
    validating_link: "Validating recovery link...",
    new_password: "New password", confirm_password: "Confirm password",
    save_new_password: "Save new password", saving: "Saving...",
    pwd_min: "Password must be at least 6 characters", pwd_mismatch: "Passwords don't match",
    pwd_updated: "Password updated successfully",
    my_orders: "My orders", my_orders_sub: "Your credentials remain available here for 30 days after purchase.",
    no_orders: "You haven't placed any orders yet.",
    delivered_creds: "Delivered credentials:",
    expired_30d: "Availability has expired (30 days).",
    expires_in: "Expires in", day: "day", days: "days",
    show: "Show", hide: "Hide", no_creds: "No credentials linked.",
    footer_rights: "Digital assets marketplace",
    // Wallet
    wallet_title: "My wallet", wallet_balance: "Available balance",
    wallet_balance_hint: "Use your balance to buy any product in the store.",
    wallet_add: "Add balance", wallet_finalize: "Complete top-up",
    wallet_credit_label: "Wallet credit", wallet_you_pay: "You pay",
    wallet_fee_provider: "Provider fee (5%)", wallet_fee_fixed: "Provider fixed fee",
    wallet_fees_total: "Total fees", wallet_total_pay: "Total to pay",
    wallet_history: "History", wallet_no_tx: "No transactions yet.",
    wallet_back: "Back to store", wallet_methods: "Methods: credit card, debit card and Pix (when enabled by the provider). The payment provider's fee (5% + R$0.50) is added to the charge — the credit applied to your wallet is always the nominal amount you chose.",
    wallet_custom: "Custom amount", wallet_custom_hint: "Enter how much to credit (min R$10, max R$5,000)",
    wallet_continue: "Continue", wallet_invalid_amount: "Invalid amount (R$10 – R$5,000)",
    // Product detail
    pd_unit_price: "Unit price", pd_quantity: "Quantity", pd_max: "max",
    pd_total: "Total", pd_wallet_balance: "Wallet balance",
    pd_add_balance: "Add balance", pd_buy_balance: "Buy with balance",
    pd_login_to_buy: "Sign in to buy", pd_sold: "sold",
    pd_confirm_title: "Confirm purchase",
    pd_will_debit: "Will be debited", pd_balance_after: "Balance after purchase",
    pd_after_purchase: "After purchase your credentials will be available in",
    pd_confirm_btn: "Confirm and go to My orders",
    pd_purchase_done: "Purchase completed! Check My orders.",
    pd_login_first: "Sign in to buy",
    pd_available_30d: 'Available for 30 days in "My orders"',
    // Support
    nav_support: "Support",
    sup_title: "Support", sup_sub: "Open a ticket and our team will reply shortly.",
    sup_count: "ticket(s)", sup_open_ticket: "Open ticket", sup_new_ticket: "Open new ticket",
    sup_no_tickets: "You don't have any tickets yet.",
    sup_subject: "Subject", sup_subject_ph: "E.g.: Order #NR-001023 not delivered",
    sup_message: "Message", sup_message_ph: "Describe what happened...",
    sup_reply_ph: "Write your message...",
    sup_status_open: "Open", sup_status_closed: "Closed",
    sup_opened_at: "Opened on", sup_last_activity: "Last activity:",
    sup_new_reply: "New reply", sup_you: "You", sup_support: "Support",
    sup_closed_msg: "This ticket was closed by support.",
    sup_sending: "Sending...", sup_too_long: "Text too long", sup_msg_too_long: "Message too long",
    sup_create_err: "Failed to create ticket", sup_created: "Ticket opened",
  },
} as const;

type Key = keyof typeof dict.pt;

interface AppCtx {
  lang: Lang; setLang: (l: Lang) => void;
  theme: Theme; setTheme: (t: Theme) => void;
  t: (k: Key) => string;
}
const Ctx = createContext<AppCtx>({} as AppCtx);

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLangS] = useState<Lang>(() => (localStorage.getItem("lang") as Lang) || "pt");
  const [theme, setThemeS] = useState<Theme>(() => (localStorage.getItem("theme") as Theme) || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);

  const t = (k: Key) => dict[lang][k] || dict.pt[k] || k;
  return <Ctx.Provider value={{ lang, setLang: setLangS, theme, setTheme: setThemeS, t }}>{children}</Ctx.Provider>;
};

export const useApp = () => useContext(Ctx);
